
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from './axios'
Vue.prototype.$http = axios


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import './../node_modules/slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';

Vue.prototype.$http.defaults.withCredentials = true;

// Check if we're on Products or Home page and add class immediately before Vue mounts
if (window.location.pathname === '/Products' || window.location.pathname === '/products') {
  document.body.classList.add('products-page-active');
} else if (window.location.pathname === '/' || window.location.pathname === '') {
  document.body.classList.add('home-page-active');
}

new Vue({
	router:router,
	render: h => h(App),
}).$mount('#app')
